import { accountQueryKeys } from 'queries/account-query-keys';

export const webhookQueryKeys = {
    webhooks: (accountId: number) => [...accountQueryKeys.current(accountId), 'webhooks'],
    webhookById: (accountId: number, webhookId: string) => [
        ...webhookQueryKeys.webhooks(accountId),
        webhookId,
    ],
    webhooksFiltered: (accountId: number, params: { page?: number; limit?: number }) => [
        ...webhookQueryKeys.webhooks(accountId),
        params,
    ],
    webhookEvents: (accountId: number) => [...accountQueryKeys.current(accountId), 'webhookEvents'],
    webhookActivities: (
        accountId: number,
        webhookId: string,
        params: { page?: number; limit?: number },
    ) => [...webhookQueryKeys.webhookById(accountId, webhookId), params, 'webhookActivities'],
};
